import classNames from "classnames";
import React, { memo } from "react";

const Input = memo(
  ({
    label,
    id,
    name,
    type,
    placeholder,
    onChange,
    value,
    isCommonStyle = false,
  }) => {
    return (
      <div
        className={classNames({
          'form-control': !isCommonStyle,
          'universal-input': !!isCommonStyle,
        })}
      >
        <label
          htmlFor={id}
        >
          {label}
        </label>

        <input
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          className={classNames({
            'form-control--phone': name === 'phone',
          })}
        />
      </div>
    );
  }
);

export default Input;
